import * as yup from "yup";

export const GeneralSettingsSetupValidationSchema = yup.object().shape({
  // repeatColumnHeading: yup
  // .string()
  // .required("Repeat Column Heading is required"),
  // timeFormat: yup
  // .number()
  // .required("Time Format is required"),
  // employeeId: yup
  // .number()
  // .required("Employee Id is required"),
  // vacationPayOnPaidVacPay: yup
  // .number()
  // .required("Vacation Pay on Paid Vac Pay is required"),
  // payrollRemittancesMethod: yup
  // .number()
  // .required("Payroll Remittances Method is required"),
  // vacationPay: yup
  // .number()
  // .required("Vacation pay is required"),
  // payoutVacationpay: yup
  // .number()
  // .required("Payout Vacation pay is required"),
	// notes: yup
  //   .string()
  //   .max(100, "Maximum length 100 characters"),
});
